export type RegionId = string;

export interface TaxIdRegionMeta<
  TValidateProps = Record<string, any>,
  TGenerateProps = Record<string, any>,
> {
  /**
   * Region for which the meta information applies.
   */
  region: RegionId;

  /**
   * Validates a given `taxId`.
   *
   * @param taxId Tax ID to validate.
   * @param properties Additional properties for validation.
   * @returns
   * Validity of the given `taxId`.
   */
  validate: (
    taxId: string,
    properties?: Partial<TValidateProps>,
  ) => TaxIdValidity;

  /**
   * Generates a `taxId` from the given properties.
   *
   * @param properties Propertis from which the tax ID is generated.
   * @returns
   * A valid tax ID
   */
  generate?: (properties: TGenerateProps) => string;
}

export enum TaxIdValidity {
  /** The validity of the Tax ID is unknown. */
  Unknown,
  /** Length of the tax ID is invalid. */
  InvalidLength,
  /** Tax ID has invalid characters. */
  InvalidCharacters,
  /** Checksum of the tax ID is invalid. */
  InvalidChecksum,
  /**
   * The additional data provided results in a different
   * tax ID. This must not necessarily mean it is invalid.
   */
  MismatchAdditionalData,
  /** The tax ID is valid. */
  Valid,
}
